export { default } from './BlogLayout'
